// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"86bca198","453":"a8b3c430"}[chunkId] + ".chunk.js";
};